<template>
  <!-- Lista de valores: anatomia -->
  <div class="modal fade" id="ModalAnatomiaLOV" tabindex="-1" aria-labelledby="ModalLabelLOV" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h5 class="modal-title" id="ModalLabelLOV">
            <i class="fa fa-user-plus"></i> {{ tituloLOV }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          </button>
        </div>
        <div class="mb-3">
          <table class="tablaBusqueda">
            <tr>
              <td><label for="nombre" class="form-label">Nombre</label></td>
              <td><input type="text" class="form-control" id="nombreBusquedaLOV" name="nombreBusquedaLOV"
                  v-model="nombreBusquedaLOV" style="width: 500px; text-transform:uppercase;" required></td>
              <td>
                <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaLOV(1)"
                  title="Buscar registros">
                  Buscar
                </button>
              </td>
            </tr>
          </table>
        </div>
        <table class="table table-striped" id="sampleTableLOV">
          <thead>
            <tr>
              <th scope="col">nombre</th>
              <th scope="col">descripcion</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="anatomia in datosPaginadosLOV" :key="anatomia.idanatomia">
                  <td><a href="#" v-on:click="seleccionarRegistro(anatomia.idAnatomia, anatomia.nombre)"
                      data-bs-target="#ventanaModal" data-bs-toggle="modal">{{ anatomia.nombre }}</a></td>
            </tr>
          </tbody>
        </table>
        <nav aria-label="Page navigation example">
          <div class="row" style="text-align: center;">
            <div class="col"></div>
            <div class="col">
              <ul class="pagination">
                <li class="page-item" v-on:click="getPreviousPageLOV()"><a class="page-link" href="#">Anterior</a></li>
                <li class="page-item"><a class="page-link" href="#">{{ paginaActualLOV }}</a></li>
                <li class="page-item" v-on:click="getNextPageLOV()"><a class="page-link" href="#">Siguiente</a></li>
              </ul>
            </div>
            <div class="col"></div>
          </div>
        </nav>
      </div>
    </div>
  </div>
<!-- Lista de valores: Anatomia -->
</template>
<script>
import api from "@/services/api";
export default {
  data() {
    return {
      // Lista de valores: Anatomia
      nombreBusquedaLOV: '',
      tituloLOV: 'Lista de Anatomia',
      AnatomiaLOV: [],
      elementosPorPaginaLOV: 10,
      datosPaginadosLOV: [],
      paginaActualLOV: 1
      // Lista de valores: Anatomia
    }
  },
  methods: {
    // Lista de valores: Anatomia
    totalPaginasLOV() {
      return Math.ceil(this.AnatomiaLOV.length / this.elementosPorPaginaLOV)
    },
    getDataPaginaLOV(noPagina) {
      if (this.nombreBusquedaLOV != null && this.nombreBusquedaLOV !== ""){
        api.get('/vwanatomias/nombre/'+this.nombreBusquedaLOV).then(response=>{
          this.AnatomiaLOV = response.data.reverse();
          this.paginaActualLOV = noPagina;
          this.datosPaginadosLOV = [];
          let ini = (noPagina * this.elementosPorPaginaLOV) - this.elementosPorPaginaLOV;
          let fin = (noPagina * this.elementosPorPaginaLOV);
          this.datosPaginadosLOV = this.AnatomiaLOV.slice(ini, fin);
          this.datosPaginadosLOV = this.AnatomiaLOV.slice(ini, fin);
        });
      }
      else{
        alert("ERROR: Ingrese un valor de consulta Anatomia");
      }
    },
    getPreviousPageLOV() {
      if (this.paginaActualLOV > 1) {
        this.paginaActualLOV--;
      }
      this.getDataPaginaLOV(this.paginaActualLOV);
    },
    getNextPageLOV() {
      if (this.paginaActualLOV < this.totalPaginasLOV()) {
        this.paginaActualLOV++;
      }
      this.getDataPaginaLOV(this.paginaActualLOV);
    },
    seleccionarRegistro(p_idAnatomia, p_nombre) {
      this.$emit("DatosAnatomia", { idAnatomia: p_idAnatomia, nombre: p_nombre });
    }
  }
}
</script>
